import { Phone, Mail, MapPin } from "lucide-react";
import { useQuote } from "@/context/QuoteContext";
import { SITE, IMAGES } from "@/data/site";

export const Footer = () => {
  const { openQuote } = useQuote();

  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-400">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-14 pb-28 lg:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <img
                src={IMAGES.logoBadge}
                alt="Templar Armor Roofing & Construction logo"
                className="h-14 w-14 rounded-lg object-contain bg-white p-1"
              />
              <div className="leading-none">
                <span className="block font-display font-extrabold text-lg text-white">TEMPLAR ARMOR</span>
                <span className="block text-[10px] tracking-[0.22em] font-semibold text-red-600">ROOFING & CONSTRUCTION</span>
              </div>
            </div>
            <p className="mt-4 max-w-md leading-relaxed">
              {SITE.tagline}. Serving {SITE.areas} since {SITE.founded}. Roofing, home renovation, and all levels of
              commercial construction, owner-verified, warranty-backed, and built to last.
            </p>
            <p className="mt-3 font-display font-semibold text-slate-300 italic">"{SITE.motto}"</p>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-4">Services</h4>
            <ul className="space-y-2.5">
              {["Roof Repair", "Roof Replacement", "Home Renovation", "Commercial Construction", "Commercial Garage Renovations", "HOA & Multi-Family", "Storm Damage"].map((s) => (
                <li key={s}>
                  <button onClick={() => openQuote(s)} className="hover:text-red-600 transition-colors text-left" data-testid={`footer-service-${s.replace(/\s+/g, "-").toLowerCase()}`}>
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-4">Get In Touch</h4>
            <ul className="space-y-3">
              <li>
                <a href={SITE.phoneHref} data-testid="footer-phone" className="flex items-center gap-2.5 hover:text-red-600 transition-colors">
                  <Phone className="h-4 w-4 text-red-600" /> {SITE.phone}
                </a>
              </li>
              <li>
                <a href={SITE.emailHref} data-testid="footer-email" className="flex items-center gap-2.5 hover:text-red-600 transition-colors break-all">
                  <Mail className="h-4 w-4 text-red-600 shrink-0" /> {SITE.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin className="h-4 w-4 text-red-600 mt-1 shrink-0" /> {SITE.areas}
              </li>
            </ul>
            <button
              data-testid="footer-quote-btn"
              onClick={() => openQuote()}
              className="mt-5 inline-flex items-center justify-center rounded-full bg-red-700 hover:bg-red-800 text-white font-bold px-6 h-11 transition-colors"
            >
              Get a Free Quote
            </button>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-sm">
          <p>License #950130, Licensed & Insured</p>
          <p>Serving California since {SITE.founded}</p>
        </div>
      </div>
    </footer>
  );
};
